import { FormattedMessage } from 'react-intl';
import ScheduleOutlined from '@mui/icons-material/ScheduleOutlined';
import { alpha, useTheme } from '@mui/material/styles';
import { Box, Chip, Divider, Stack, Typography } from '@mui/material';

/**
 * Renders `openNow` and a list of human-readable opening hour lines from API payload.
 *
 * @param {object} props
 * @param {{ openNow?: boolean, openingHours?: string[] }} [props.businessHours]
 */
function BusinessHours({ openNow, openingHours }) {
  const theme = useTheme();

  const rows = Array.isArray(openingHours) ? openingHours : [];
  const hasStatus = typeof openNow === 'boolean';

  if (!hasStatus && rows.length === 0) {
    return null;
  }

  return (
    <>
      <Divider
        flexItem
        sx={{ borderColor: alpha(theme.palette.divider, 0.9) }}
      />
      <Stack spacing={1.25}>
        <Stack direction="row" alignItems="center" spacing={0.75}>
          <ScheduleOutlined
            sx={{ fontSize: 18, color: 'text.secondary', flexShrink: 0 }}
          />
          <Typography variant="subtitle2" fontWeight={700}>
            <FormattedMessage
              id="BUSINESS_HOURS"
              defaultMessage="Business hours"
            />
          </Typography>
        </Stack>
        {hasStatus && (
          <Box>
            <Chip
              size="small"
              label={openNow ? 'Open now' : 'Closed'}
              color={openNow ? 'success' : 'default'}
              variant={openNow ? 'filled' : 'outlined'}
              sx={{ fontWeight: 600 }}
            />
          </Box>
        )}
        {rows.length > 0 && (
          <Stack spacing={0.35} sx={{ pl: 0.25 }}>
            {rows.map(line => (
              <Typography
                key={String(line)}
                variant="body2"
                color="text.secondary"
                sx={{ lineHeight: 1.5 }}>
                {line}
              </Typography>
            ))}
          </Stack>
        )}
      </Stack>
    </>
  );
}

export default BusinessHours;
